import { render, staticRenderFns } from "./TSZ_Presupuestos.vue?vue&type=template&id=9cbe390c&"
import script from "./TSZ_Presupuestos.vue?vue&type=script&lang=js&"
export * from "./TSZ_Presupuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports